import { memo } from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { SxProps, Theme } from "@mui/material/styles";

// -----------------------------------------------------------------------------

const ServiceConnectionStep = memo(function ServiceConnectionStep({
  disabled,
  children,
  sx = {},
}: ServiceConnectionStepProps) {
  return (
    <Paper elevation={1} sx={sx}>
      <Box
        sx={{
          p: 1.5,
          opacity: disabled ? 0.33 : 1,
          pointerEvents: disabled ? "none" : "all",
        }}
      >
        {children}
      </Box>
    </Paper>
  );
});

export default ServiceConnectionStep;

// -----------------------------------------------------------------------------

interface ServiceConnectionStepProps {
  children: React.ReactNode;
  disabled: boolean;
  sx?: SxProps<Theme>;
}
